<template>
  <v-data-table :headers="headers"
                hide-default-footer
                :items="campaigns"
                :items-per-page="-1"
                :footer-props="{'items-per-page-options': [50, 100]}"
                :loading="loading"
                :search="search"
                height="80vh"
                fixed-header>
    <template v-slot:item.name="{item:campaign}">
      <router-link :to="{name: `${$root.routePrefix}.mailcoach.campaign.show`, params: {campaignID: campaign.id}}">
        {{ campaign.name }}
      </router-link>
    </template>
    <template v-slot:item.status="{item:campaign}">
      <CampaignStatusChip :campaign="campaign">
      </CampaignStatusChip>
    </template>
    <template v-slot:item.scheduled_at="{item:campaign}">
      <date-tool-tip v-if="campaign.scheduled_at"
                     :date="campaign.scheduled_at">
      </date-tool-tip>
    </template>
    <template v-slot:item.sent_at="{item:campaign}">
      <date-tool-tip v-if="campaign.sent_at"
                     :date="campaign.sent_at">
      </date-tool-tip>
    </template>
    <template v-slot:item.list.name="{item: campaign}">
      <template v-if="campaign.list?.name">
        {{ campaign.list.name }}
      </template>
      <v-chip v-else
              color="warning"
              dark
              label
              small
              class="text-center font-weight-bold"
              text-color="white">
        List deleted
      </v-chip>
    </template>
    <template v-slot:item.metrics.engagement_score="{item: campaign}">
      {{ campaign.metrics.engagement_score | number }}
    </template>
    <template v-slot:item.metrics.created_count="{item: campaign}">
      {{ campaign.metrics.created_count | number }}
    </template>
    <template v-slot:item.metrics.delivered_count="{item: campaign}">
      {{ campaign.metrics.delivered_count | number }}
    </template>
    <template v-slot:item.metrics.delivered_rate="{item: campaign}">
      {{ (100 * campaign.metrics.delivered_rate) | number(1) }}%
    </template>
    <template v-slot:item.metrics.unique_open_count="{item: campaign}">
      {{ campaign.metrics.unique_open_count | number }}
    </template>
    <template v-slot:item.metrics.unique_click_count="{item: campaign}">
      {{ campaign.metrics.unique_click_count | number }}
    </template>
    <template v-slot:item.metrics.click_rate="{item: campaign}">
      {{ (100 * campaign.metrics.click_rate) | number(1) }}%
    </template>

    <template v-slot:item.metrics.unique_failed_count="{item: campaign}">
      {{ campaign.metrics.unique_failed_count | number }}
    </template>
    <template v-slot:item.metrics.failed_rate="{item: campaign}">
      {{ (100 * campaign.metrics.failed_rate) | number(1) }}%
    </template>
  </v-data-table>
</template>
<style lang="scss">
.Column__Template {
  max-width: 150px;
}
</style>
<script>
import {mapGetters} from 'vuex';
import DateToolTip from '../../../components/DateToolTip';
import CampaignStatusChip from "./CampaignStatusChip";

export default {
  components: {CampaignStatusChip, DateToolTip},
  props: {
    campaigns: {
      type: Array,
      required: true,
    },
    includeSender: false,
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
    search: {
      type: String,
      required: false,
    },
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters([
      'isEngagementScoreEnabled', // MLD-5240
    ]),
    headers() {
      let headers = [
        {
          text: 'Campaign',
          value: 'name',
          width: '300px',
          cellClass: 'text-truncate',
        },
        { // MLD-5240
          text: 'Template',
          value: 'template.name',
          cellClass: 'Column__Template',
        },
        { // MLD-7225
          text: 'Subject',
          value: 'message_data.subject',
          cellClass: 'Column__Template',
        },
        { // MLD-3809
          text: 'Email List',
          value: 'list.name',
          cellClass: 'text-nowrap', // MLD-5750
        },
        { // MLD-3412
          text: 'Status',
          value: 'status',
        },
        { // MLD-3412
          text: 'Scheduled',
          value: 'scheduled_at',
        },
        {
          text: 'Sent',
          value: 'sent_at',
        },
        {
          text: 'Engagement Score',
          value: 'metrics.engagement_score',
          align: 'end',
          cellClass: 'text-end',
        },
        {
          text: 'Recipients',
          value: 'metrics.created_count',
          cellClass: 'text-end',
        },
        {
          text: 'Delivered',
          value: 'metrics.delivered_count',
          cellClass: 'text-end',
        },
        {
          text: 'Delivered Rate',
          value: 'metrics.delivered_rate',
          cellClass: 'text-end',
        },
        {
          text: 'Opened',
          value: 'metrics.unique_open_count',
          cellClass: 'text-end',
        },
        {
          text: 'Clicked',
          value: 'metrics.unique_click_count',
          cellClass: 'text-end',
        },
        { // MLD-3412
          text: 'CTR',
          value: 'metrics.click_rate',
          cellClass: 'text-end',
        },
        {
          text: 'Failed',
          value: 'metrics.unique_failed_count',
          cellClass: 'text-end',
        },
        { // MLD-3412
          text: 'Failed Rate',
          value: 'metrics.failed_rate',
          cellClass: 'text-end',
        },
        /*{
          text: 'Status',
          value: 'status',
        },*/
      ];
      if (this.includeSender) {
        headers.unshift({
          text: 'Sender',
          value: 'user.name',
        });
      }
      if (false === this.isEngagementScoreEnabled) { // MLD-5226
        headers = headers.filter(item => !['engagement_score'].includes(item.value));
      }
      return headers;
    },
  }
}
</script>
